var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGraphicDesign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#4da3ff",
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    stroke: "#4da3ff",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "358.661,150.058 358.661,165.731 358.661,181.405 358.661,350.145 480.653,350.145 496.327,350.145 512,350.145 512,150.058 "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "0,150.058 0,350.145 15.673,350.145 31.347,350.145 158.48,350.145 158.48,181.405 158.48,165.731 158.48,150.058 "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M512,444.709v-63.216h-15.673h-15.673H31.347H15.673H0v63.216h221.78v35.422h-62.955v31.347h194.351v-31.347H290.22 v-35.422H512z M266.752,413.362v9.561H245.07v-9.561v-12.121h21.682V413.362z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "314.023,150.058 298.35,150.058 218.697,150.058 203.024,150.058 189.827,150.058 189.827,150.674 189.827,181.405 189.827,350.145 203.024,350.145 218.697,350.145 298.35,350.145 314.023,350.145 327.314,350.145 327.314,181.405 327.314,165.731 327.314,150.674 327.314,150.058 "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "258.529,0.522 191.634,119.327 209.627,119.327 227.61,119.327 289.437,119.327 307.419,119.327 325.413,119.327 "
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraphicDesign);
export default __webpack_public_path__ + "static/media/graphic-design.a787703dbfe8a60e523644413c51a0d0.svg";
export { ForwardRef as ReactComponent };